'use strict';

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
        if (button.find("i").hasClass('fa-heart-o')) {
            button.find("i").removeClass('fa-heart-o wishlist-icon').addClass("fa-solid fa-heart heart-white");
            button.find(".icon-wishlist").removeClass('fa-heart-o wishlist-icon').addClass("fa-solid fa-heart heart-white");
        }
    } else {
        status = 'alert-danger';
    }

    if ($('.add-to-wishlist-messages').length === 0) {
        $('body').append(
            '<div class="add-to-wishlist-messages "></div>'
        );
    }
    $('.add-to-wishlist-messages').html('');
    $('.add-to-wishlist-messages')
        .append('<div class="add-to-wishlist-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-to-wishlist-messages').remove();
        button.removeAttr('disabled');
    }, 5000);
}

module.exports = {
    addToWishlist: function () {
        $('.add-to-wish-list').on('click', function (e) {
            e.preventDefault();
            var url = $(this).data('href');
            var button = $(this);
            var pid = $(this).closest('.product-detail').find('.product-id').html();
            var optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            var optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            $.spinner().start();
            $(this).attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    if (data.searchImpressionData && !data.error) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({ ecommerce: null });
                        window.dataLayer.push(JSON.parse(data.searchImpressionData));
                    }
                    if (data.removed) {
                        button.find("i").removeClass('fa-heart heart-white').addClass("fa-heart-o wishlist-icon");
                        $.spinner().stop();
                        button.removeAttr('disabled');
                        return;
                    }

                    displayMessage(data, button);
                },
                error: function (err) {
                    if (err.status === 500 && err.responseJSON.loggedin === false) {
                        var addToWishlistData = {
                            url: url,
                            pid: pid,
                            optionId: optionId,
                            optionVal: optionVal
                        };
                        localStorage.setItem('favoritePid', JSON.stringify(addToWishlistData));
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        displayMessage(err, button);
                    }
                }
            });
        });
    }
};
